import { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import NavegacaoDocumentos from "./NavegacaoDocumentos"
import { useDispatch, useSelector } from "react-redux"
import { atualizar } from "../documentosSlice"
import { getDocumentosReqPost, getPageUrlIdPasta } from "./DocumentosFuncoes"
import ModalCriarPasta from "./ModalCriarPasta"
import { ApiEndpoints, reqPut } from "../../../config/apiClient"
import LoadingModal from "../../../components/loadingModal"
import { toast } from "react-toastify"

export default function DocumentosPage() {

    // const [documentosCaminho, setDocumentosCaminho] = useState<any[]>([])
    // const [UIDados, setUIDados] = useState<any>({})
    const [showModalCriarPasta, setShowModalCriarPasta] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [loadingPage, setLoadingPage] = useState<boolean>(true)
    const loadingPasta:boolean = useSelector((state:any) => state.uiDocumentos.loadingPasta)
    const dispatch = useDispatch()
    useEffect(() => {
        document.title = "Documentos | OB PORTUS APP"
        const id_pasta = getPageUrlIdPasta()
        if (id_pasta! >= 0) {
            getDocumentos(id_pasta!)
        }
        // eslint-disable-next-line
    }, [])

    async function getDocumentos(id_pasta: number) {
        const api = await getDocumentosReqPost(id_pasta)
        if (api.status === 200) {
            dispatch(atualizar(api.data))
            // setUIDados(api.data)
        }
        setLoadingPage(false)
    }

    async function handleCriarPasta(nome: string) {
        const id_pasta = getPageUrlIdPasta()
        const dados = {
            id_pasta: null,
            id_pasta_pai: id_pasta,
            nome: nome,
            lixeira: 0
        }
        setShowModalCriarPasta(false)
        setLoading(true)
        const api = await reqPut(ApiEndpoints.documentoCriarPastas, dados)
        if (api.status === 201) {
            toast.success(`Pasta criada com sucesso!`, {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            if (id_pasta! >= 0) {
                await getDocumentos(id_pasta!)
            }
        }
        setLoading(false)
    }

    function handleCriarDocumento(mouseClick:number) {
        const id_pasta = getPageUrlIdPasta()
        let link_criar_documento = `${ApiEndpoints.baseSite}/documento/novo?pasta=${id_pasta}`
        // let link_criar_documento = `${ApiEndpoints.apiOld}/dashboard/documentos/criar?pasta=${id_pasta}`
        if (id_pasta === null || id_pasta === 0) {
            link_criar_documento = `${ApiEndpoints.baseSite}/documento/novo`
            // link_criar_documento = `${ApiEndpoints.apiOld}/dashboard/documentos/criar`
        }
        if (mouseClick === 1) {
            window.open(link_criar_documento)
            return
        }
        if (mouseClick === 0) {
            window.location.href = link_criar_documento
            return
        }
    }

    return (
        <div id="main">
            <LoadingModal show={loading} handleClose={() => { }} />
            <LoadingModal show={loadingPasta} handleClose={() => { }} />
            <ModalCriarPasta show={showModalCriarPasta} handleClose={() => { setShowModalCriarPasta(false) }} handleCriarPasta={handleCriarPasta} />
            <div className="div-row-space-between">
                <h1 id="titleMain">Assinatura de Documentos</h1>
                <div className="div-row">
                    <Button onClick={(event) => { handleCriarDocumento(event.button) }} onMouseUp={(event) => { handleCriarDocumento(event.button) }} style={{marginRight: "10px"}} onMouseDown={(event) => { if (event.button === 1) { event.preventDefault(); event.stopPropagation() } }}>Novo Documento</Button>
                    <Button onClick={() => { setShowModalCriarPasta(true) }} style={{marginRight: "10px"}}>Nova Pasta</Button>
                    <Button onClick={() => { window.location.assign(`/documentos/lixeira`) }}>Lixeira</Button>
                </div>
            </div>

            <NavegacaoDocumentos loadingPage={loadingPage} />
        </div>
    )
}
